import { useTranslation } from "react-i18next";

export const LastUsedBadge = () => {
	const { t } = useTranslation("auth");

	return (
		<span className="absolute -top-1 -right-1 rounded-full bg-success px-1.5 py-0.5 text-[10px] font-medium text-success-foreground">
			{t("last_used")}
		</span>
	);
};
